var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 24V104H8V24C8 15.2 15.2 8 24 8H472C480.8 8 488 15.2 488 24Z",
    fill: "#5CD6B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472 344H24C15.16 344 8 336.84 8 328V104H488V328C488 336.84 480.84 344 472 344Z",
    fill: "#E6E9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264 136H456V232H264V136Z",
    fill: "#FCD770"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 264H136V312H40V264Z",
    fill: "#FF826E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168 40H200V72H168V40Z",
    fill: "#E6E9ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104 40H136V72H104V40Z",
    fill: "#E6E9ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40H72V72H40V40Z",
    fill: "#E6E9ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376 264H184C175.2 264 168 271.2 168 280V344V440C168 448.8 175.2 456 184 456H392V280C392 271.2 384.8 264 376 264Z",
    fill: "#FFEAA7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280 424C315.346 424 344 395.346 344 360C344 324.654 315.346 296 280 296C244.654 296 216 324.654 216 360C216 395.346 244.654 424 280 424Z",
    fill: "#69D6F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392 378.64L472 392L448 416L488 456L456 488L416 448L392 472L389.36 456L376 376L392 378.64Z",
    fill: "#FF826E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280 288C240.304 288 208 320.304 208 360C208 399.696 240.304 432 280 432C319.696 432 352 399.696 352 360C352 320.304 319.696 288 280 288ZM267.288 384C265.928 379.12 264.912 373.76 264.392 368H295.6C295.08 373.76 294.064 379.12 292.704 384H267.288ZM286.552 400C284.312 404.512 282.016 408.256 280.008 411.16C278 408.256 275.696 404.512 273.456 400H286.552ZM264.392 352C264.912 346.24 265.928 340.88 267.288 336H292.704C294.064 340.88 295.08 346.24 295.6 352H264.392ZM273.456 320C275.696 315.488 277.992 311.744 280 308.84C282.008 311.744 284.312 315.488 286.544 320H273.456ZM255.832 320H240.88C246.856 314.152 254.144 309.656 262.24 306.936C260.064 310.704 257.848 315.048 255.832 320ZM250.776 336C249.616 340.984 248.728 346.304 248.304 352H224.64C225.456 346.352 227.104 340.976 229.48 336H250.776ZM248.304 368C248.728 373.696 249.616 379.016 250.776 384H229.48C227.104 379.024 225.456 373.648 224.64 368H248.304ZM255.832 400C257.848 404.952 260.064 409.296 262.24 413.064C254.136 410.344 246.856 405.848 240.88 400H255.832ZM304.168 400H319.12C313.144 405.848 305.856 410.344 297.76 413.064C299.936 409.296 302.152 404.952 304.168 400ZM309.224 384C310.384 379.016 311.272 373.696 311.696 368H335.36C334.544 373.648 332.896 379.024 330.52 384H309.224ZM311.696 352C311.272 346.304 310.384 340.984 309.224 336H330.52C332.896 340.976 334.544 346.352 335.36 352H311.696ZM304.168 320C302.152 315.048 299.936 310.704 297.76 306.936C305.864 309.656 313.144 314.152 319.12 320H304.168Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M459.312 416L488.648 386.664L400 371.888V352H472C485.232 352 496 341.232 496 328V24C496 10.768 485.232 0 472 0H24C10.768 0 0 10.768 0 24V328C0 341.232 10.768 352 24 352H160V440C160 453.232 170.768 464 184 464H382.56L386.664 488.648L416 459.312L456 499.312L499.312 456L459.312 416ZM24 16H472C476.408 16 480 19.592 480 24V96H16V24C16 19.592 19.592 16 24 16ZM24 336C19.592 336 16 332.408 16 328V112H480V328C480 332.408 476.408 336 472 336H400V280C400 266.768 389.232 256 376 256H184C170.768 256 160 266.768 160 280V336H24ZM184 448C179.592 448 176 444.408 176 440V280C176 275.592 179.592 272 184 272H376C380.408 272 384 275.592 384 280V369.224L366.272 366.272L379.888 448H184ZM416 436.688L397.336 455.352L385.728 385.728L455.352 397.336L436.688 416L476.688 456L456 476.688L416 436.688Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32H32V80H80V32ZM64 64H48V48H64V64Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144 32H96V80H144V32ZM128 64H112V48H128V64Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208 32H160V80H208V32ZM192 64H176V48H192V64Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M464 128H256V240H464V128ZM448 224H272V144H448V224Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32 128H48V144H32V128Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64 128H240V144H64V128Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32 160H240V176H32V160Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32 192H48V208H32V192Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64 192H80V208H64V192Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96 192H240V208H96V192Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224 224H240V240H224V224Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32 224H208V240H32V224Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32 320H144V256H32V320ZM48 272H128V304H48V272Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M192 288H208V304H192V288Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M352 288H368V304H352V288Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192 416H208V432H192V416Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.642e8f6837df8555cc892f781066fab1.svg";
export { ForwardRef as ReactComponent };